import fetchServer from "../fetchServer";

export default async function cancelEsimBooking(id) {
  let result = {
    return: 0,
    msg: "Something went wrong cancelling eSIM booking!",
    data: null,
  };

  if (!id) {
    result.msg = "Missing eSIM booking id";
    return result;
  }

  try {
    const res = await fetchServer({
      method: "POST",
      url: `/product/v1/esim/booking/cancel/${id}`,
    });
    const apiMessage = res?.data?.message;

    if (res?.status === 200 || (res?.data && !res?.data?.error)) {
      result = {
        return: 1,
        msg: apiMessage || "eSIM booking cancelled successfully",
        data: res?.data?.data || res?.data,
      };
    } else {
      result.msg =
        apiMessage ||
        res?.data?.error ||
        "Something went wrong cancelling eSIM booking!";
    }
  } catch (err) {
    result.msg = "Network Error!";
  }

  return result;
}
